var map = {
	"./ams/1.png": "bb0e",
	"./ams/2.png": "ea0f",
	"./ams/3.png": "e96b",
	"./ams/4.png": "82c8",
	"./ams/5.png": "58cc",
	"./ams/6.png": "97d4",
	"./ams/main.png": "007c",
	"./ams/main1.png": "2562",
	"./digital-marketing/1.png": "f309",
	"./digital-marketing/2.png": "70de",
	"./digital-marketing/3.png": "6d07",
	"./digital-marketing/4.png": "2bdd",
	"./digital-marketing/5.png": "0824",
	"./digital-marketing/6.png": "0eba",
	"./digital-marketing/banner bgi.jpg": "decd",
	"./digital-marketing/bgi.jpg": "65c2",
	"./digital-marketing/bgi3.jpg": "3863",
	"./digital-marketing/img.png": "d136",
	"./ecommerce/1.png": "9bb2",
	"./ecommerce/2.png": "a139",
	"./ecommerce/3.png": "d99d",
	"./ecommerce/4.png": "4068",
	"./ecommerce/5.png": "2d2a",
	"./ecommerce/6.png": "03c6",
	"./ecommerce/img.png": "3600",
	"./img.png": "9337",
	"./mobile-app-androids/1.png": "5713",
	"./mobile-app-androids/2.png": "031c",
	"./mobile-app-androids/3.png": "6d2a",
	"./mobile-app-androids/4.png": "fd11",
	"./mobile-app-androids/5.png": "a32a",
	"./mobile-app-androids/6.png": "3a26",
	"./mobile-app-androids/img.png": "c19b",
	"./mobile-app-cross-platforms/1.png": "f166",
	"./mobile-app-cross-platforms/2.png": "65a7",
	"./mobile-app-cross-platforms/3.png": "2f64",
	"./mobile-app-cross-platforms/4.png": "4a2f",
	"./mobile-app-cross-platforms/5.png": "b3f4",
	"./mobile-app-cross-platforms/6.png": "9be6",
	"./mobile-app-cross-platforms/flut.png": "a622",
	"./mobile-app-cross-platforms/img.jpg": "9eb8",
	"./mobile-app-cross-platforms/react.png": "cf15",
	"./mobile-app-cross-platforms/xzam.png": "ff29",
	"./mobile-app-ios/1.png": "613f",
	"./mobile-app-ios/2.png": "6532",
	"./mobile-app-ios/3.png": "7c3c",
	"./mobile-app-ios/4.png": "dbca",
	"./mobile-app-ios/5.png": "674d",
	"./mobile-app-ios/6.png": "72e9",
	"./mobile-app-ios/img.png": "7972",
	"./mobile-app-ios/ios-img.png": "bcac",
	"./mobile-app/1.png": "ffba",
	"./mobile-app/2.png": "6e5b",
	"./mobile-app/3.png": "c18e",
	"./mobile-app/4.png": "56a3",
	"./mobile-app/5.png": "19f5",
	"./mobile-app/6.png": "1293",
	"./mobile-app/feature01.png": "0025",
	"./mobile-app/feature02.png": "e1e9",
	"./mobile-app/feature03.png": "acf1",
	"./mobile-app/img.png": "1c77",
	"./orm/1.png": "4af7",
	"./orm/2.png": "8b14",
	"./orm/3.png": "694d",
	"./orm/4.png": "aeb8",
	"./orm/img.png": "c2fb",
	"./seo/1.png": "bbfc",
	"./seo/2.png": "11e0",
	"./seo/3.png": "327d",
	"./seo/4.png": "5276",
	"./seo/5.png": "df4db",
	"./seo/6.png": "56fc",
	"./seo/img.png": "c1b9c",
	"./smm-img.png": "9637",
	"./smm/1.png": "6002",
	"./smm/2.png": "9dbe",
	"./smm/3.png": "5af6",
	"./smm/4.png": "2521",
	"./smm/5.png": "4487",
	"./smm/6.png": "170a",
	"./smm/bgi.png": "5b96",
	"./smm/img.png": "56c3",
	"./software-development/1.png": "ec02",
	"./software-development/2.png": "5491",
	"./software-development/3.png": "45fa",
	"./software-development/4.png": "8ad4",
	"./software-development/5.png": "bfc0",
	"./software-development/6.png": "2a52",
	"./software-development/img.png": "568b",
	"./web-app/1.png": "9a5a",
	"./web-app/2.png": "de39",
	"./web-app/3.png": "c159",
	"./web-app/4.png": "2319",
	"./web-app/5.png": "e94e",
	"./web-app/6.png": "45ac",
	"./web-app/img.png": "2b8e",
	"./website-development/1.png": "1206",
	"./website-development/2.png": "425d",
	"./website-development/3.png": "b04f",
	"./website-development/4.png": "58e6",
	"./website-development/5.png": "43ee",
	"./website-development/6.png": "9092",
	"./website-development/asp.png": "46a6",
	"./website-development/html.png": "c3ff",
	"./website-development/img.png": "514c",
	"./website-development/java.png": "bcf7",
	"./website-development/php.png": "0f02",
	"./website-development/pytho.png": "91b5",
	"./website-development/word.png": "28d3",
	"./why-choose/ams/why-1.png": "379d",
	"./why-choose/ams/why-2.png": "7c9d",
	"./why-choose/ams/why-3.png": "01a4",
	"./why-choose/ams/why-4.png": "d000",
	"./why-choose/ams/why-5.png": "c44d",
	"./why-choose/ams/why-6.png": "793f",
	"./why-choose/android/why-1.jpg": "0181",
	"./why-choose/android/why-2.jpg": "3e97",
	"./why-choose/android/why-3.jpg": "6544",
	"./why-choose/android/why-4.jpg": "9159",
	"./why-choose/android/why-5.jpg": "d457",
	"./why-choose/android/why-6.jpg": "c469",
	"./why-choose/cross/why-1.jpg": "f43b",
	"./why-choose/cross/why-2.jpg": "543c",
	"./why-choose/cross/why-3.jpg": "66bc",
	"./why-choose/cross/why-4.jpg": "b519",
	"./why-choose/cross/why-5.jpg": "1825",
	"./why-choose/cross/why-6.jpg": "ea65",
	"./why-choose/digital-marketing/why-1.jpg": "70b7",
	"./why-choose/digital-marketing/why-2.jpg": "dd9e",
	"./why-choose/digital-marketing/why-3.jpg": "81e3",
	"./why-choose/digital-marketing/why-4.jpg": "3508",
	"./why-choose/digital-marketing/why-5.jpg": "aadd",
	"./why-choose/digital-marketing/why-6.jpg": "9511",
	"./why-choose/ecommerce/why-1.jpg": "fd3d",
	"./why-choose/ecommerce/why-2.jpg": "96bd",
	"./why-choose/ecommerce/why-3.jpg": "c669",
	"./why-choose/ecommerce/why-4.jpg": "3aee",
	"./why-choose/ecommerce/why-5.jpg": "a34b",
	"./why-choose/ecommerce/why-6.jpg": "33bc",
	"./why-choose/ios/why-1.jpg": "d40e",
	"./why-choose/ios/why-2.jpg": "02e1",
	"./why-choose/ios/why-3.jpg": "487d",
	"./why-choose/ios/why-4.jpg": "a780",
	"./why-choose/ios/why-5.jpg": "baf4",
	"./why-choose/mob-app/why-1.jpg": "8738",
	"./why-choose/mob-app/why-2.jpg": "faa2",
	"./why-choose/mob-app/why-3.jpg": "1a66",
	"./why-choose/mob-app/why-4.jpg": "1efe",
	"./why-choose/mob-app/why-5.jpg": "7bc2",
	"./why-choose/mob-app/why-6.jpg": "ed09",
	"./why-choose/orm/why-1.jpg": "c86c",
	"./why-choose/orm/why-2.jpg": "8b60",
	"./why-choose/orm/why-3.jpg": "108c",
	"./why-choose/orm/why-4.jpg": "eab8",
	"./why-choose/orm/why-5.jpg": "4a61",
	"./why-choose/orm/why-6.jpg": "10d6",
	"./why-choose/seo/why-1.jpg": "50a8",
	"./why-choose/seo/why-2.jpg": "0e9f",
	"./why-choose/seo/why-3.jpg": "62fa",
	"./why-choose/seo/why-4.jpg": "b359",
	"./why-choose/seo/why-5.jpg": "e7ed",
	"./why-choose/seo/why-6.jpg": "91d3",
	"./why-choose/smm/why-1.jpg": "8ea6",
	"./why-choose/smm/why-2.jpg": "5c88",
	"./why-choose/smm/why-3.jpg": "ba7e",
	"./why-choose/smm/why-4.jpg": "ea7f",
	"./why-choose/smm/why-5.jpg": "100f",
	"./why-choose/smm/why-6.jpg": "a1a1",
	"./why-choose/software/why-1.jpg": "3859",
	"./why-choose/software/why-2.jpg": "00d0",
	"./why-choose/software/why-3.jpg": "94b3",
	"./why-choose/software/why-4.jpg": "ff75",
	"./why-choose/software/why-5.jpg": "6f55",
	"./why-choose/software/why-6.jpg": "3bbf",
	"./why-choose/web-app/why-1.jpg": "5112",
	"./why-choose/web-app/why-2.jpg": "972b",
	"./why-choose/web-app/why-3.jpg": "f61f",
	"./why-choose/web-app/why-4.jpg": "e80e",
	"./why-choose/web-app/why-5.jpg": "98f9",
	"./why-choose/web-app/why-6.jpg": "5a97",
	"./why-choose/website/why-1.jpg": "8376",
	"./why-choose/website/why-2.jpg": "9f71",
	"./why-choose/website/why-3.jpg": "0b3c",
	"./why-choose/website/why-4.jpg": "1c79",
	"./why-choose/website/why-5.jpg": "f2a2",
	"./why-choose/website/why-6.jpg": "2c40"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6d17";